<template>
    <q-card
        :inline="inline"
        :class="['card', 'q-ma-sm', {inEdit: inEdit, draggingOver: draggingOver, deleted: model.deleted}]"
        :style="style"
        ref="card"
        v-if="model">

        <q-card-title>
            <div v-if="! inEdit" :class="{deleted: model.deleted !== undefined}">{{model.label}}</div>
            <q-input v-else v-model="model.label"></q-input>
        </q-card-title>

        <!--<q-card-media class="media q-pa-md"-->
                      <!--flat-->
                      <!--@dragover.native.prevent="dragover"-->
                      <!--@dragleave.native="dragleave"-->
                      <!--@dragenter.native="dragenter"-->
                      <!--@drop.native="drop">-->
            <!--<generic-viewer :src="model.thumbUrl || model.movieUrl || model.audioUrl"/>-->
        <!--</q-card-media>-->

        <q-card-main class="main">
            <!--<p class="description" v-if="! inEdit" v-html="model.description"></p>-->
            <!--<q-editor class="description"-->
                      <!--v-if="inEdit && model.description != null"-->
                      <!--v-model="model.description"/>-->

            <div class="badges q-ma-sm text-right">
                <q-btn round class="q-ma-sm"
                       icon="fingerprint"
                       :disabled="true"
                       v-if="isBasePole"></q-btn>
                <group-switcher @change="value => model.group = value"
                                :value="model.group"
                                :disabled="!inEdit || !model.publicationInformation || model.publicationInformation.status !== 'Unpublished'"
                                v-if="! isBasePole"/>
                <template v-if="! isBasePole && model.phase === 2">
                    <div class="q-mt-md" v-if="! inEdit">Kategoria: {{categoryName}}</div>
                    <category-chooser v-else
                                      :category="model.category"
                                      @selected="setCategory"/>

                    <div class="q-mt-md" v-if="model.phase === 2 && !inEdit">
                        <a href="#" @click.prevent="$router.push({name: 'survey-edit', params: {surveyId: relatedSurvey.surveyId}})" v-if="relatedSurvey">Ankieta</a>
                        <span v-else-if="model.category">
                            Brak ankiety. <a href="#" @click.prevent="$router.push({name: 'survey-add-qualifying-with-params', params: {category: model.category, group: model.group}})">Dodaj</a>
                        </span>
                    </div>
                </template>
            </div>
        </q-card-main>

        <q-card-actions v-if="!inEdit" align="end" class="actions">
            <publish-button :model="model" v-if="! isBasePole && !model.deleted" what="pole"/>
            <q-btn v-if="model.phase === 2 && ! isBasePole && !model.deleted" flat round icon="file_copy" @click.native="cloneAndEdit">
                <q-tooltip>
                    Wykonaj kopię
                </q-tooltip>
            </q-btn>
            <!--<q-btn flat round icon="visibility" v-if="editable" @click.native="viewStructure"/>-->
            <q-btn v-if="! model.deleted" flat round icon="edit" @click.native="goToEdit(model.poleId)">
                <q-tooltip>
                    Edytuj
                </q-tooltip>
            </q-btn>
            <q-btn v-if="model.deleted" flat round icon="more" @click.native="goToEdit(model.poleId)">
                <q-tooltip>
                    Podgląd
                </q-tooltip>
            </q-btn>
            <q-btn flat round icon="delete" @click.native="confirmAndDelete"  v-if="! isBasePole && !model.deleted">
                <q-tooltip>
                    Usuń
                </q-tooltip>
            </q-btn>
        </q-card-actions>

        <q-card-actions v-if="inEdit" align="end" class="actions"
                        @dragover.native.prevent="dragover"
                        @dragleave.native="dragleave"
                        @dragenter.native="dragenter"
                        @drop.native="dropBackground">
        </q-card-actions>
    </q-card>
</template>

<script>
    import QCardTitle from 'quasar-framework/src/components/card/QCardTitle'
    import QCardMedia from 'quasar-framework/src/components/card/QCardMedia'
    import QCardMain from 'quasar-framework/src/components/card/QCardMain'
    import QCardActions from 'quasar-framework/src/components/card/QCardActions'
    import QIcon from 'quasar-framework/src/components/icon/QIcon'
    import QBtn from 'quasar-framework/src/components/btn/QBtn'
    import QEditor from 'quasar-framework/src/components/editor/QEditor'
    import QField from 'quasar-framework/src/components/field/QField'
    import GenericViewer from './viewers/GenericViewer'
    import QCard from 'quasar-framework/src/components/card/QCard'
    import QChipsInput from 'quasar-framework/src/components/chips-input/QChipsInput'
    import GroupSwitcher from '../GroupSwitcher'
    import PublishButton from './PublishButton'
    import CategoryChooser from '../CategoryChooser'
    import QTooltip from 'quasar-framework/src/components/tooltip/QTooltip'

    export default {
        name: 'PoleComponent',
        components: {
            QTooltip,
            CategoryChooser,
            PublishButton,
            GroupSwitcher,
            QChipsInput,
            QCard,
            GenericViewer,
            QField,
            QEditor,
            QBtn,
            QIcon,
            QCardActions,
            QCardMain,
            QCardMedia,
            QCardTitle,
        },
        props: ['model', 'editable', 'inEdit', 'inline', 'isBasePole'],
        methods: {
            goToEdit (poleId) {
                this.$router.push({
                    name: 'pole-edit',
                    params: {poleId},
                })
            },
            confirmAndDelete () {
                if (this.model.poleId) {
                    this.$q.dialog({
                        title: `Potwierdź usunięcie bieguna`,
                        message: `Czy na pewno usunąć biegun ${this.model.label}?`,
                        ok: 'Usuń',
                        cancel: 'Anuluj',
                        position: 'top',
                    }).then(() => {
                        this.$store.dispatch('remove', {
                            what: 'pole',
                            id: this.model.poleId,
                            soft: true,
                        })
                    }).catch(() => {

                    })
                } else {
                    this.$emit('delete')
                }
            },

            viewStructure () {
                this.$router.push({name: 'pole-structure', params: {poleId: this.model.poleId}})
            },

            dragenter () {

            },
            dragover () {
                if (this.inEdit) {
                    this.draggingOver = true
                }
            },
            dragleave () {
                if (this.inEdit) {
                    this.draggingOver = false
                }
            },
            drop (e) {
                if (this.inEdit) {
                    e.preventDefault()

                    try {
                        const tasklet = JSON.parse(e.dataTransfer.getData('text'))
                        switch (tasklet.type) {
                            case 'audio':
                                this.model.audioUrl = tasklet.src
                                this.model.movieUrl = null
                                this.model.thumbUrl = null
                                break;
                            case 'video':
                                this.model.audioUrl = null
                                this.model.movieUrl = tasklet.src
                                this.model.thumbUrl = null
                                break;
                            case 'picture':
                                this.model.audioUrl = null
                                this.model.movieUrl = null
                                this.model.thumbUrl = tasklet.src
                                break;
                            // case 'survey':
                            //     break;
                            // case 'article':
                            //     break;
                        }
                    } catch (ee) {
                        // ...
                    }

                    this.draggingOver = false
                }
            },
            dropBackground (e) {
                if (this.inEdit) {
                    try {
                        this.$set(this.model, 'backgroundUrl', JSON.parse(e.dataTransfer.getData('text')).urlPath)
                    } catch (ee) {
                        // ...
                    }
                }
            },
            selected (item) {
                this.model.category = item.value
            },
            setCategory (e) {
                this.$set(this.model, 'category', e)
            },
            cloneAndEdit () {
                const pole = this.model

                const poleId = this.$uuid()

                const model = {
                    ...pole,
                    poleId,
                    label: 'Kopia ' + pole.label,
                    description: pole.description,
                    category: pole.category,
                    group: pole.group,
                    phase: pole.phase,
                    thumbUrl: pole.thumbUrl || '',
                    ...pole.audioUrl ? {audioUrl: pole.audioUrl} : {},
                    ...pole.movieUrl ? {movieUrl: pole.movieUrl} : {},
                    backgroundUrl: pole.backgroundUrl,
                    steps: pole.steps.map((step, stepIndex) => {
                        const poleStepId = this.$uuid()

                        return {
                            ...step,
                            poleStepId,
                            pos: stepIndex,
                            poleId: poleId,
                            label: this.$store.state.STEP_NAMES[stepIndex + 1],
                            tasks: step.tasks.map((t, taskIndex) => {
                                const poleStepTaskId = this.$uuid()

                                return {
                                    poleStepTaskId,
                                    poleStepId,
                                    poleId,
                                    label: t.label,
                                    description: t.description,
                                    thumbUrl: t.thumbUrl || '',
                                    ...t.audioUrl ? {audioUrl: t.audioUrl} : {},
                                    ...t.movieUrl ? {movieUrl: t.movieUrl} : {},
                                    ...t.shortMovieUrl ? {shortMovieUrl: t.shortMovieUrl} : {},
                                    order: t.order || [],
                                    opt: t.opt,
                                    tasklets: (t.tasklets || []).map(tl => {
                                        return {
                                            ...tl,
                                            parentId: poleStepTaskId
                                        }
                                    }),
                                    backgroundUrl: t.backgroundUrl,
                                    backgroundColor: t.backgroundColor,
                                    pos: taskIndex,
                                    badges: t.badges || [],
                                    extras: {
                                        ...t.extras.externalLink ? {externalLink: t.extras.externalLink} : {}
                                    }
                                }
                            }),
                        }
                    }),
                    ...pole.phase === 2 ? {
                        metricsStep: ((metricsStep) => {
                            const poleStepId = this.$uuid();

                            return {
                                ...metricsStep,
                                poleStepId,
                                poleId: pole.poleId,
                                tasks: metricsStep.tasks.map((t, tIndex) => {
                                    const poleStepTaskId = this.$uuid();

                                    return {
                                        ...t,
                                        poleStepTaskId,
                                        poleId: pole.poleId,
                                        poleStepId,
                                        extras: {
                                            ...tIndex !== 0 ? {startDelayedDays: t.extras.startDelayedDays} : {},
                                            stepometer: {
                                                active: true,
                                                minNumberOfSteps: t.extras.stepometer.minNumberOfSteps,
                                                averageSpeed: t.extras.stepometer.averageSpeed,
                                            },

                                        },
                                        tasklets: (t.tasklets || []).map(tl => ({
                                            ...tl,
                                            parentId: poleStepTaskId
                                        })),
                                        badges: t.badges || [],
                                        pos: tIndex,
                                    }
                                })
                            }
                        })(pole.metricsStep),
                    } : {},
                    publicationInformation: undefined,
                }

                this.$store.dispatch('create', {
                    what: 'pole',
                    item: model,
                    id: model.poleId
                })
            }
        },
        data () {
            return {
                draggingOver: false,
            }
        },
        computed: {
            style () {
                if (this.model && this.model.backgroundUrl) {
                    return `background: url(${this.$store.state.MEDIA_PREFIX_FOR_IMG + this.model.backgroundUrl}); background-size: cover`
                }
            },
            relatedSurvey () {
                if (this.model.phase === 2) {
                    return this.$store.getters.qualifyingSurvey.find(s => {
                        return s.category === this.model.category
                            && s.group === this.model.group
                    })
                }
            },
            isNew () {
                return this.$store.getters.pole.find(p => p.poleId === this.model.poleId) === undefined
            },
            categoryName () {
                if (this.model.category) {
                    const c = this.$store.getters.category.find(c => c.category === this.model.category)
                    if (c) {
                        return c.label
                    }

                    return ''
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    .card {
        .actions {
            background: gainsboro;
            height: 58px;
        }

        .description {
            height: 150px;
            overflow: auto;
        }

        border-radius: 20px;

        &.deleted {
            text-decoration: line-through;
        }
    }

    .card:not(.inEdit) {
        width: 350px;
        /*height: 500px;*/
        overflow: hidden;
        position: relative;

        .media {
            height: 200px;
        }
    }

    .card.inEdit {
        width: 350px;
        position: relative;

        .media {

        }

        .description {
            height: initial;
        }

        .main {

        }

        &.draggingOver {
            border: 1px solid red;
        }
    }
</style>
